module.exports = __webpack_public_path__ + "static/img/en.646a111c.png";